import { render, staticRenderFns } from "./Fundraisers.vue?vue&type=template&id=389e3561"
import script from "./Fundraisers.vue?vue&type=script&lang=js"
export * from "./Fundraisers.vue?vue&type=script&lang=js"
import style0 from "./Fundraisers.vue?vue&type=style&index=0&id=389e3561&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports